import { AutomatedTextsActions } from './partials/automated-text'
import { DashboardActions } from './partials/dashboard'
import { DocketEntryEditActions } from './partials/docket-entry-edit'
import { PrintActions } from './partials/print'
import { UploadLinksActions } from './partials/upload-links'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'

export const DocketEntryActions = {
  ...AutomatedTextsActions,
  ...DashboardActions,
  ...DocketEntryEditActions,
  ...PrintActions,
  ...UploadLinksActions,

  addAttendeeToDocketEntry: async ({ commit }, { docketEntryId, partyId }) => {
    return axiosRequest.
      post(`docket_entries/${docketEntryId}/attendances`, { party_id: partyId }).
      then(({ data }) => commit('rehydrateDocketEntryModel', { docketEntryId, data: data.docket_entry }, { root: true })).
      catch(handleError)
  },
  updateDocketEntryAttendance: async ({ commit }, { docketEntryId, attendanceId, params }) => {
    return axiosRequest.
      patch(`docket_entries/${docketEntryId}/attendances/${attendanceId}`, params).
      then(({ data }) => {
        commit('rehydrateDocketEntryModel', { docketEntryId, data: data.docket_entry }, { root: true })
        commit('updateExistingRecordPartyModel', data.party, { root: true })
        commit(`${LEGAL_CASE_NAMESPACE}/updateLegalCaseParty`, data.party, { root: true })
      }).
      catch(handleError)
  },
  destroyDocketEntryAttendance: async ({ commit }, { docketEntryId, attendanceId }) => {
    return axiosRequest.
      delete(`docket_entries/${docketEntryId}/attendances/${attendanceId}`).
      then(({ data }) => commit('rehydrateDocketEntryModel', { docketEntryId, data: data.docket_entry }, { root: true })).
      catch(handleError)
  },
  downloadDocketEntryAttachments: async ({ commit }, docketEntryId) => {
    return axiosRequest.
      get(`docket_entries/${docketEntryId}/download_attachments`).
      then(({ data }) => commit('downloads/addDownloadRequest', data.download_id, { root: true })).
      catch(handleError)
  },
  downloadDocketEntriesAttachments: async ({ commit }, docketEntryIds) => {
    return axiosRequest.
      post('docket_entries/download_attachments', { ids: docketEntryIds }).
      then(({ data }) => commit('downloads/addDownloadRequest', data.download_id, { root: true })).
      catch(handleError)
  },
  cancelAppointment: async ({ commit }, { docketEntryId, params }) => {
    return axiosRequest.
      post(`docket_entries/${docketEntryId}/cancel`, params).
      then(({ data }) => commit('rehydrateDocketEntryModel', { docketEntryId, data }, { root: true })).
      catch(handleError)
  },
  getCaseLastUndoneDocketEntries: async (_, requestData) => {
    return axiosRequest.
      get(`/legal_cases/${requestData.legalCaseId}/docket_entries/${requestData.id}/undone`).
      then(response => response.data).
      catch(handleError)
  },
  getTasksAssignees: async ({ commit }) => {
    return axiosRequest.
      get('/tasks/assignees').
      then(response => commit('setTasksAssignees', response.data)).
      catch(handleError)
  },
  getTransferableEntries: async (_, data) => {
    return axiosRequest.
      get('/docket_entries/transferable', { params: data }).
      then(response => response.data).
      catch(handleError)
  },
  getUsersWithAssignedDocketEntries: async () => {
    return axiosRequest.
      get('/docket_entries/assignees').
      then(({ data }) => data || []).
      catch(handleError)
  },
  markDocketEntryAsDone: async ({ commit, rootState }, docketEntryId) => {
    return axiosRequest.
      put(`/docket_entries/${docketEntryId}/is_done`).
      then(({ data }) => {
        const index = rootState.models.currentDocketEntries.findIndex(d => d.id === docketEntryId)
        commit('updateDocketEntriesModel', { index: index, data: data.docket_entry }, { root: true })
      })
  },
  markDocketEntryAsNotDone: async ({ commit, rootState }, docketEntryId) => {
    return axiosRequest.
      delete(`/docket_entries/${docketEntryId}/is_done`).
      then(({ data }) => {
        const index = rootState.models.currentDocketEntries.findIndex(d => d.id === docketEntryId)
        commit('updateDocketEntriesModel', { index: index, data: data.docket_entry }, { root: true })
      })
  },
  transferEntriesAssignment: async ({ commit }, data) => {
    return axiosRequest.
      patch('/docket_entries/transfer', data).
      then(({ data }) => {
        commit('mass-reassignment/addAssignmentRequest', data.job_id, { root: true })
        return data.message
      }).
      catch(handleError)
  },
  updateDocketEntryChecklist: async ({ commit, rootState }, { docketEntryId, checklist }) => {
    return axiosRequest.
      put(`/docket_entries/${docketEntryId}/checklist`, { checklist }).
      then(({ data }) => {
        const index = rootState.models.currentDocketEntries.findIndex(d => d.id === docketEntryId)
        commit('updateDocketEntriesModel', { index: index, data: data.docket_entry }, { root: true })
        return data.docket_entry.checklist
      })
  },
  userHasNoEntries: async (_, { userId, actionTypes = ['event', 'task'], legalCaseId }) => {
    return axiosRequest.
      get(`/users/${userId}/docket_entries`, {
        params: {
          filters: {
            action_type: actionTypes,
            legal_case_id: legalCaseId,
            is_done: false,
          },
        },
      }).
      then(response => response.data.docket_entries.length === 0)
  },
}
